import { StyleRules } from '@material-ui/core/styles';
import { AlertClassKey } from '@material-ui/lab/Alert';

import { core as theme } from '../styles/core';

export const MuiAlert: Partial<StyleRules<AlertClassKey>> = {
  root: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
  },
  standardInfo: {
    backgroundColor: theme.palette.info.lighter,
    color: theme.palette.grey[700],
  },
  standardError: {
    backgroundColor: theme.palette.error.lighter,
    color: theme.palette.grey[700],
  },
  standardWarning: {
    backgroundColor: theme.palette.warning.lighter,
    color: theme.palette.grey[700],
  },
  standardSuccess: {
    backgroundColor: theme.palette.success.lighter,
    color: theme.palette.grey[700],
  },
  icon: {
    marginRight: theme.spacing(1),
    padding: `${theme.spacing(1)}px 0`,
  },
  action: {
    alignItems: 'flex-start',
    color: theme.palette.grey[500],
    marginTop: theme.spacing(1),
  },
};
